import { useEffect, useState, useCallback } from "react";
import { globalFileServer } from "../../../../axiosInstance";
import { checkout } from "../../../server/Order";
import showAlert from "../../../server/ShowAlert";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearCart } from "../../../server/CollectSite";
import PrivateArea from "../../privateArea/PrivateArea";
import PayPopup from "../shopCart/PayPopup";
import { getStationToCustomer } from "../../../server/Station";
import axios from "axios";
import { awsUrl } from "../../../../axiosInstance";
import { SaveNedarimData } from "../../../server/Payment";
import CouponCode from "./CouponCode";
import html2pdf from "html2pdf.js";
import { OrderReceiptTemplate } from "./OrderReceiptTemplate";

const ShopCart = () => {
  const dispatch = useDispatch();
  const {
    user,
    _orderTime,
    productsInCart,
    deliveryPrice,
    orderSum,
    totalSum,
    stationId,
    deliveryAvailable,
  } = useSelector((state) => ({
    user: state.user.user,
    stationId: state.user.stationId,
    orderTime: state.productsInCart.orderTime,
    productsInCart: state.productsInCart.productsInCart,
    orderSum: state.productsInCart.orderSum,
    totalSum: state.productsInCart.totalSum,
    deliveryPrice: state.productsInCart.deliveryPrice,
    deliveryAvailable: state.productsInCart.deliveryAvailable,
    // MinPrice: state.productsInCart.station.MinPrice,
    // MinFreeDeleviry: state.productsInCart.station.MinFreeDeleviry,
  }));

  const navigate = useNavigate();
  const [allSum, setAllSum] = useState(0);
  const [toPayPopup, setToPayPopup] = useState(false);
  // const [selectedAddres, setSelectedAddres] = useState(false);
  const [station, setStation] = useState(null);
  const [paymentOrder, setPaymentOrder] = useState(0);
  const [verified, setVerified] = useState(false);
  const [verifiedGetSms, setVerifiedGetSms] = useState(
    user.VerifiedGetSms || false,
  );
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [appliedCouponCode, setAppliedCouponCode] = useState(null);
  const [comment, setComment] = useState("");

  const getStation = useCallback(() => {
    getStationToCustomer(stationId).then((x) => setStation(x.data));
  }, [stationId]);

  useEffect(() => {
    let PaymentOrg = parseFloat(totalSum) + parseFloat(orderSum);
    if (
      PaymentOrg < station?.MinFreeDeleviry ||
      (!station?.MinFreeDeleviry && station?.MinFreeDeleviry !== 0)
    ) {
      PaymentOrg += deliveryPrice;
      setAllSum(PaymentOrg);
    }
    PaymentOrg -= couponDiscount;
    setPaymentOrder(Math.max(0, PaymentOrg));
  }, [totalSum, station, orderSum, deliveryPrice, couponDiscount]);

  useEffect(() => {
    getStation();
  }, [getStation]);

  const handleCouponApplied = (discount, couponCode) => {
    setCouponDiscount(discount);
    setAppliedCouponCode(couponCode);
  };
  const splitPaymentsPay = (
    _succ,
    PaymentMataraTokenId,
    NumPayment,
    responseData,
  ) => {
    if (!_succ) {
      setToPayPopup(false);
      return;
    }

    const fullAddress = `${user.addrStreet || ""} ${user.addrHouse || ""}, קומה ${user.addrFloor || ""}, דירה ${user.addrApartment || ""}`;

    const params = { ...responseData, address: fullAddress };

    checkout(params, stationId)
      .then(async (res) => {
        dispatch({
          type: "CHECKOUT_SUCCESS",
          payload: res.data,
        });
        const orderData = res.data;
        let base64Result = "";

        try {
          const element = document.createElement("div");
          element.style.width = "190mm";
          element.innerHTML = OrderReceiptTemplate(
            orderData,
            user,
            fullAddress,
            paymentOrder,
            productsInCart,
            deliveryPrice,
          );
          const opt = {
            margin: [10, 5, 20, 5],
            filename: `order_${orderData.id}.pdf`,
            image: { type: "jpeg", quality: 1 },
            html2canvas: { scale: 3, useCORS: true },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
          };
          const worker = html2pdf()
            .set(opt)
            .from(element)
            .toPdf()
            .get("pdf")
            .then(function (pdf) {
              const totalPages = pdf.internal.getNumberOfPages();
              for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(10);
                pdf.text(i + " / " + totalPages, 105, 285, { align: "center" });
              }
            });

          const pdfArrayBuffer = await worker.output("arraybuffer");

          const bytes = new Uint8Array(pdfArrayBuffer);
          let binary = "";
          for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          base64Result = btoa(binary);

          console.log("PDF generated successfully!");
        } catch (pdfErr) {
          console.error("PDF generation error:", pdfErr);
        }

        const mailPayload = {
          OrderWebId: orderData.id || orderData.orderWebId,
          name: `${user.firstName} ${user.lastName || ""}`,
          email: user.email,
          address: fullAddress,
          customerId: user.id,
          amount: paymentOrder,
          updated: new Date().toLocaleDateString("he-IL"),
          Digit4: orderData?.payment?.rawPayment?.LastNum || "****",
          PdfBase64: base64Result,
        };
        setToPayPopup(false);

        await axios.post(`${awsUrl}/v1/orders`, mailPayload, {
          headers: { Authorization: `bearer ${localStorage.jwtToken}` },
        });

        SaveNedarimData(
          orderData,
          orderData.id || orderData.OrderWebId,
          PaymentMataraTokenId,
        );
        dispatch(clearCart());
        showAlert({ msgTitle: "הזמנה נרשמה בהצלחה.", msgType: "success" });
        navigate("/");
      })
      .catch((error) => {
        setToPayPopup(false);
        console.error("orderPost Error:", error);
        showAlert({ msgTitle: "שגיאה ברישום ההזמנה", msgType: "error" });
      });
  };
  const toPay = () => {
    //if (!orderTime) {
    //error("אנא בחר זמן משוער להגעת המשלוח ", "error");
    //return;
    //}
    //if (!selectedAddres) {
    //error("אנא בחר כתובת למשלוח", "error");
    //return;
    //}
    if (!verified) {
      error("יש לאשר את התקנון לפני ביצוע ההזמנה", "error");
      return;
    }

    if (!deliveryAvailable) {
      error("לא ניתן לבצע הזמנה במחיר זה", "error");
      return;
    }

    const products = productsInCart.filter((element) => element.quantity > 0);
    if (!products.length) {
      console.log();
      navigate("/");
    }
    if (products.length) {
      const sumBeforeDiscount = parseFloat(totalSum) + parseFloat(orderSum);
      if (sumBeforeDiscount >= station?.MinPrice || station?.MinPrice == null) {
        setToPayPopup(true);
      } else {
        error("מינימום הזמנה: " + station?.MinPrice + " ש״ח", "error");
      }
    }
  };

  const error = (textError, type) => {
    showAlert({ msgTitle: textError, msgType: type });
  };

  const handleChange = (nameChanged) => {
    const _updatedData = {
      ...user,
      [nameChanged]: nameChanged === "Verified" ? !verified : !verifiedGetSms,
    };

    if (nameChanged === "Verified") {
      setVerified(!verified);
    } else if (nameChanged === "VerifiedGetSms") {
      setVerifiedGetSms(!verifiedGetSms);
    }

    //dispatch(PutCustomer(updatedData));
  };

  return (
    <div className="shop-cart">
      <PrivateArea
        parent="cart"
        // setSelectedAddres={setSelectedAddres}
      />
      <textarea
        className="input-area"
        type="text"
        placeholder="הערה להזמנה"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      ></textarea>
      <CouponCode
        userId={user.Id}
        orderSum={parseFloat(totalSum) + parseFloat(orderSum)}
        onCouponApplied={handleCouponApplied}
      />
      <span className="checkbox-and-btn">
        <div className="checkbox-style">
          <label>
            <input
              type="checkbox"
              checked={verified}
              onChange={() => handleChange("Verified")}
            />
            <span className="verify">
              {" "}
              הנני מאשר/ת כי קראתי את{" "}
              <a
                target="_blank"
                href={globalFileServer + "policy_form.pdf"}
                rel="noreferrer"
              >
                תקנון{" "}
              </a>
              אתר ׳המזון׳ ואת מדיניות הפרטיות, וברצוני להירשם בכפוף
              לתנאיהם.{" "}
            </span>
          </label>
          <label className="verify">
            <input
              type="checkbox"
              checked={verifiedGetSms}
              onChange={() => handleChange("VerifiedGetSms")}
            />
            הנני מאשר/ת לקבל הטבות, ועדכונים בדוא״ל וב-SMS (ניתן להפסיק את קבלת
            העדכונים בכל עת).
          </label>
        </div>
        <button onClick={toPay} className="to-pay">
          סיום קנייה &gt;{" "}
        </button>
      </span>
      {toPayPopup ? (
        <PayPopup
          SumPay={allSum}
          tranmode={true}
          closePayPopup={(_succ, cardId, numPaymentSelect, responseData) =>
            splitPaymentsPay(_succ, cardId, numPaymentSelect, responseData)
          }
          coupons={appliedCouponCode ? [appliedCouponCode] : []}
          comment={comment}
          afterDiscount={Math.abs(paymentOrder)}
        />
      ) : null}
    </div>
  );
};

export default ShopCart;
